import * as React from 'react';

export const useCacheRef = <T = undefined>(initialData?: T) => {
  const currentDataRef = React.useRef(initialData);

  const setData = React.useCallback((data: T) => {
    currentDataRef.current = data;
  }, []);

  const hasData = React.useCallback(() => currentDataRef.current !== undefined, []);

  const getData = React.useCallback(() => currentDataRef.current, []);

  return { getData, setData, hasData };
};
